import { useState } from 'react';
import { Link } from 'react-router-dom';
import { C, Logo, BtnOrange, metalGradient, scrollTo, useIsMobile } from '../styles';

const navItems = [['How it works', 'how'], ['Services', 'services'], ['Pricing', 'pricing'], ['Manufacturers', 'manufacturers']];

export default function Nav() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const linkStyle = {
    fontFamily: "'Instrument Sans', sans-serif",
    fontSize: 12, fontWeight: 500,
    color: C.mut, letterSpacing: '0.02em',
    transition: 'color 0.15s',
  };

  // Close the menu first, then scroll on the next frame so the dropdown is
  // removed from layout before we measure the target's position.
  const go = (id) => {
    setOpen(false);
    requestAnimationFrame(() => scrollTo(id));
  };

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: 'rgba(15,26,36,0.96)',
      backdropFilter: 'blur(14px)',
      borderBottom: `1px solid ${C.bdr}`,
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto', padding: isMobile ? '11px 16px' : '13px 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 8 : 14, flexShrink: 0 }}>
          <Logo size={isMobile ? 32 : 44} />
          <div>
            <div style={{ fontSize: isMobile ? 17 : 22, lineHeight: 0.95 }}>
              <span style={{ ...metalGradient, fontSize: isMobile ? 17 : 22, letterSpacing: isMobile ? 1.5 : 3 }}>Metal</span>
              <span style={{
                fontFamily: "'Rajdhani', sans-serif", fontWeight: 700,
                fontSize: isMobile ? 17 : 22, color: C.navy, letterSpacing: isMobile ? 1.5 : 3,
              }}>Match</span>
            </div>
            {!isMobile && (
              <div style={{
                fontSize: 9, color: C.dim, letterSpacing: '0.22em',
                textTransform: 'uppercase', marginTop: 2,
              }}>Ontario Fabrication Network</div>
            )}
          </div>
        </div>

        {isMobile ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
            <BtnOrange onClick={() => go('submit')} style={{ padding: '9px 12px', fontSize: 11, whiteSpace: 'nowrap' }}>Get Quotes — Free</BtnOrange>
            <button
              onClick={() => setOpen(o => !o)}
              aria-label={open ? 'Close menu' : 'Open menu'}
              aria-expanded={open}
              style={{
                background: 'none', border: 'none', padding: 6,
                display: 'flex', flexDirection: 'column', justifyContent: 'center',
                gap: 5, width: 34, height: 34, flexShrink: 0,
              }}
            >
              {[0, 1, 2].map(i => (
                <span key={i} style={{
                  display: 'block', height: 2, width: 22, borderRadius: 2, background: C.txt,
                  transition: 'transform 0.2s, opacity 0.2s',
                  transform: open ? (i === 0 ? 'translateY(7px) rotate(45deg)' : i === 2 ? 'translateY(-7px) rotate(-45deg)' : 'none') : 'none',
                  opacity: open && i === 1 ? 0 : 1,
                }} />
              ))}
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
            {navItems.map(([label, id]) => (
              <button key={id} onClick={() => scrollTo(id)} style={{ ...linkStyle, background: 'none', border: 'none' }}
                onMouseEnter={e => e.currentTarget.style.color = C.txt}
                onMouseLeave={e => e.currentTarget.style.color = C.mut}
              >{label}</button>
            ))}
            <Link to="/blog" style={linkStyle}
              onMouseEnter={e => e.currentTarget.style.color = C.txt}
              onMouseLeave={e => e.currentTarget.style.color = C.mut}
            >Blog</Link>
            <BtnOrange onClick={() => scrollTo('submit')}>Get Quotes — Free</BtnOrange>
          </div>
        )}
      </div>

      {/* Mobile dropdown */}
      {isMobile && open && (
        <div style={{
          borderTop: `1px solid ${C.bdr}`,
          background: 'rgba(15,26,36,0.98)',
          padding: '8px 16px 16px',
          display: 'flex', flexDirection: 'column',
        }}>
          {navItems.map(([label, id]) => (
            <button key={id} onClick={() => go(id)} style={{
              ...linkStyle, fontSize: 15, color: C.txt, background: 'none', border: 'none',
              textAlign: 'left', padding: '14px 4px', borderBottom: `1px solid ${C.bdr}`, width: '100%',
            }}>{label}</button>
          ))}
          <Link to="/blog" onClick={() => setOpen(false)} style={{
            ...linkStyle, fontSize: 15, color: C.txt, padding: '14px 4px',
          }}>Blog</Link>
        </div>
      )}
    </nav>
  );
}
